import { createFileRoute } from '@tanstack/react-router';

import NegotiationOverviewPage from '@/areas/negotiations/Negotiations/NegotiationOverviewPage/NegotiationOverviewPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/negotiations/$negotiationId/_sidebar/overview')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <NegotiationOverviewPage {...pathParams} />;
}
